export default function SkeletonInstructorSection() {
  return (
    <section
      className="advisor_section section_padding"
      aria-busy="true"
      aria-label="Loading instructors"
    >
      <div className="container">
        <div className="section_title mb-8">
          <div className="flex items-center space-x-3 mb-3">
            <div className="w-8 h-8 rounded-full bg-gray-300 animate-pulse"></div>
            <div className="h-8 w-48 rounded bg-gray-300 animate-pulse"></div>
          </div>
          <div className="h-5 w-64 rounded bg-gray-300 animate-pulse"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4 lg:gap-6 section-content-wrap">
          {[1, 2, 3, 4].map((item) => (
            <div
              key={item}
              className="instructor-card flex space-x-4 p-4 border border-gray-300 rounded-lg shadow-sm bg-white min-h-[160px]"
            >
              {/* Image Skeleton */}
              <div className="w-20 h-20 rounded-full bg-gray-300 animate-pulse flex-shrink-0"></div>

              {/* Text Skeleton */}
              <div className="flex-1 flex flex-col justify-center space-y-3">
                <div className="h-6 w-3/4 rounded bg-gray-300 animate-pulse"></div>
                <div className="h-4 w-1/2 rounded bg-gray-300 animate-pulse"></div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center md:mt-8 mt-6">
          <div className="inline-block h-10 w-40 rounded bg-gray-300 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
}
